import axios from "axios";
import Config from "../../../config";

const v2_actionGetCustomFieldValues = (leadId) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/crm/leads/${leadId}/custom-field-values`
    });
};

export default v2_actionGetCustomFieldValues;
